import React from 'react';
import classnames from 'classnames';
import { TierPresentationsC } from '../../../../constants/TierPresentations';
import { ONBOARDING_TIER_OPTIONS_PROMO_PERIOD_PROMO } from '../../../../constants/Copy';
import { TIER_IDS } from '../../../../constants/Tiers';
import TierList from './TierList';
import { formatPrice } from '../../../../helpers/number';

import './TierDescriptionSavod.scss';

const TierDescription = ({ tierId, pricing, selected, onClick, savodTier }) => {
	const tierPresentation = TierPresentationsC[tierId];
	const testId = `tierdetails-container--${tierId}`;
	return (
		<article
			className={classnames('tierdescriptionSavod', {
				['tierdescriptionSavod--selected']: selected,
			})}
			key={tierId}
			onClick={() => onClick && onClick(tierId)}
			data-test={testId}
		>
			<div
				className={classnames('tierdescriptionSavod__header', {
					['tierdescriptionSavod__header--selected']: selected,
				})}
			>
				<div className="tierdescriptionSavod__header--title-wrapper">
					<h2 className="tierdescriptionSavod__title" data-test="tierdetails-title">
						{tierPresentation.title}
					</h2>
					<div
						className={classnames('tierdescriptionSavod__radio', {
							['tierdescriptionSavod__radio--selected']: selected,
						})}
					></div>
				</div>
				<div className="tierdescriptionSavod__header--content-wrapper">
					<div className="tierdescriptionSavod__header--row">
						{tierPresentation.label && (
							<span
								className={classnames('tierdescriptionSavod__label', {
									['tierdescriptionSavod__label--selected']: selected,
								})}
								data-test="tierdetails-current"
							>
								{tierPresentation.label}
							</span>
						)}
						<div className="tierdescriptionSavod__header--pricing">
							<span className="tierdescriptionSavod__header--price">
								{tierId === TIER_IDS.FREE
									? ONBOARDING_TIER_OPTIONS_PROMO_PERIOD_PROMO
									: `€${pricing}`}
							</span>
							{tierId !== TIER_IDS.FREE && (
								<span
									className={classnames('tierdescriptionSavod__header--pricing-period', {
										['tierdescriptionSavod__header--pricing-period--selected']: selected,
									})}
								>
									/ maand
								</span>
							)}
						</div>
					</div>
					{savodTier && (
						<div className="tierdescriptionSavod__header--row tierdescriptionSavod__header--savod">
							<span className="tierdescriptionSavod__label--preposition">of</span>
							<span
								className={classnames('tierdescriptionSavod__label', {
									['tierdescriptionSavod__label--selected']: selected,
								})}
								data-test="tierdetails-current"
							>
								{savodTier.label}
							</span>
							<div className="tierdescriptionSavod__header--pricing">
								<span className="tierdescriptionSavod__header--price">
									&euro;{formatPrice(savodTier.price)}
								</span>
								<span
									className={classnames('tierdescriptionSavod__header--pricing-period', {
										['tierdescriptionSavod__header--pricing-period--selected']: selected,
									})}
								>
									/ maand
								</span>
							</div>
						</div>
					)}
				</div>
			</div>
			<div className="tierdescriptionSavod__features" data-test="tierdescription-features">
				<TierList tierFeatures={tierPresentation} />
			</div>
			{savodTier && (
				<>
					<span
						className={classnames('tierdescriptionSavod__floating-chevron', {
							['tierdescriptionSavod__floating-chevron--selected']: selected,
						})}
					></span>
					<span
						className={classnames('tierdescriptionSavod__floating-label', {
							['tierdescriptionSavod__floating-label--selected']: selected,
						})}
					>
						of
						<span className="tierdescriptionSavod__floating-label--label">{savodTier.label}</span>€
						{savodTier.price}
					</span>
				</>
			)}
		</article>
	);
};

export default TierDescription;
